import * as z from 'zod'
import { useCustomError } from 'src/utils/custom-errors.hook'
import { SubmitHandler, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useCallback } from 'react'
import { SendThreadMessageMutation } from 'src/api/api.generated'
import { FetchResult } from '@apollo/client'

export const chatSchema = z.object({
  message: z.string().min(1),
  isNote: z.boolean().default(false),
})

export type ChatSchema = z.infer<typeof chatSchema>

export default function useCharForm({ onSubmit }: { onSubmit: (formValue: ChatSchema) => Promise<FetchResult<SendThreadMessageMutation>> }) {
  const customErrorMap = useCustomError()
  z.setErrorMap(customErrorMap)
  const { control, handleSubmit, watch, setValue } = useForm<ChatSchema>({ resolver: zodResolver(chatSchema) })

  const submitHandler: SubmitHandler<ChatSchema> = useCallback(
    async (data: ChatSchema) => {
      const result = await onSubmit(data)
      if (!result.errors) {
        setValue('message', '')
      }
    },
    [onSubmit],
  )

  const onFormSubmit = useCallback(handleSubmit(submitHandler), [handleSubmit, submitHandler])

  const formValue = watch()

  return { onFormSubmit, control, formValue, setValue }
}
